module.exports = __webpack_public_path__ + "static/img/24.dca71ca4.gif";